<template>
	<div>
		<vue-final-modal
			v-model="show"
			name="qrmodal"
			classes="flex justify-center items-center"
		>
			<!-- content-class="relative flex flex-col max-h-full mx-4 p-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900" -->

			<template v-slot="{ params }">
				<div class="flex flex-col gap-y-4 items-center">
					<div
						class="modal-container flex flex-col gap-y-4 items-center px-8 py-6 border bg-white"
					>
						<div class="title mt-2">{{ params.title }}</div>
						<div ref="qrPrint" class="qr-code-image">
							<template v-if="params.QRImageURL">
								<img :src="params.QRImageURL" />
							</template>
							<template v-else>
								<QRContent ref="qrcontent" :text="params.QRContent" :logoSrc="params.avatarURL"></QRContent>
							</template>
						</div>
						<div class="indicator">
							<p>扫一扫或者长按识别</p>
							<p>立即访问</p>
						</div>
						<!-- <button class="save-image-button w-full" @click="saveImage" hidden>
							保存图片
						</button> -->
					</div>
					<button class="md:mt-8 mt-4" @click="show = false">
						<div class="close"></div>
					</button>
				</div>
			</template>
		</vue-final-modal>
	</div>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import QRContent from "@/components/cards/functional/QRContentView.vue";
// import FileSaver from "file-saver";

// https://vue-final-modal.org/zh-Hant/api
export default {
	components: {
		VueFinalModal,
		QRContent,
	},
	data: () => ({
		show: false,
	}),
	watch: {
		show: function(val) {
			if (!val) {
				// make some cleanups?
			}
		},
	},
	methods: {
		// async saveImage() {

		// 	const el = this.$refs.qrPrint;
		// 	const options = {
		// 		type: "dataURL",
		// 		useCORS: true,
		// 	};
		// 	let url = await this.$html2canvas(el, options);
		// 	let blob = this.dataURItoBlob(url);
		// 	// console.log(blob);
		// 	FileSaver.saveAs(blob, "nice.png");
		// },
		// dataURItoBlob(dataURI) {
		// 	// convert base64 to raw binary data held in a string
		// 	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		// 	var byteString = atob(dataURI.split(",")[1]);

		// 	// separate out the mime component
		// 	var mimeString = dataURI
		// 		.split(",")[0]
		// 		.split(":")[1]
		// 		.split(";")[0];

		// 	// write the bytes of the string to an ArrayBuffer
		// 	var ab = new ArrayBuffer(byteString.length);

		// 	// create a view into the buffer
		// 	var ia = new Uint8Array(ab);

		// 	// set the bytes of the buffer to the correct values
		// 	for (var i = 0; i < byteString.length; i++) {
		// 		ia[i] = byteString.charCodeAt(i);
		// 	}

		// 	// write the ArrayBuffer to a blob, and you're done
		// 	var blob = new Blob([ab], { type: mimeString });
		// 	return blob;
		// },
	},
};
</script>
<style scoped>
.modal-container {
	border-radius: 24px;
	/* max-width: 90%; */
}

.close {
	width: 40px;
	height: 40px;
	background: url("~@/assets/images/icon-modal-close.png");
	background-size: contain;
}
.qr-code-image {
	width: 200px;
	height: 200px;
}
.qr-code-image img {
	object-fit: contain;
}

.title {
	font-size: 15px;
	font-weight: 500;
}
.indicator {
	font-size: 14px;
	color: #888;
	text-align: center;
}
.save-image-button {
	background-color: var(--theme-text-color);
	color: white;
	font-size: 15px;
	font-weight: 500;
	height: 40px;
	border-radius: 20px;
}
</style>
